var ERROR_FIELDS = {
    //Filled
    FILLED_CORRECT: 0,
    FILLED_ERROR: 1,
    //EMAIL
    EMAIL_CORRECT: 10,
    EMAIL_NULL_OR_EMPTY: 11,
    EMAIL_REGEX: 12,
    //PASSWORD
    PASSWORD_CORRECT: 20,
    PASSWORD_NULL_OR_EMPTY: 21,
    PASSWORD_MINIMUM_LENGTH: 22,
    PASSWORD_MAXIMUM_LENGTH: 23,
    PASSWORD_AT_LEAST_ONE_LOWERCASE: 24,
    PASSWORD_AT_LEAST_ONE_UPPERCASE: 25,
    PASSWORD_AT_LEAST_ONE_NUMBER: 26,
    PASSWORD_AT_LEAST_ONE_SPECIAL_CHARACTER: 27,
    //NUMBERS
    ONLY_NUMBERS: 40,
    ONLY_NUMBERS_ERROR: 41,
    //IBAN
    IBAN_CORRECT: 60,
    IBAN_REGEX_ERROR: 61,
    IBAN_LENGTH_ERROR: 62,
    //BIC
    BIC_CORRECT: 70,
    BIC_LENGTH_ERROR: 72,
    //FIELDS
    FIELDS_CORRECT: 100,
    FIELDS_NULL_OR_EMPTY: 101,
    FIELDS_MAXIMUM_MENGTH: 102,
};
export default ERROR_FIELDS;
